import type { Tenant } from '@xpanse/ui';

import { useQuery } from '@tanstack/react-query';

import { AuthService } from 'src/utils/api';

const getTenants = async (): Promise<Tenant[]> => {
  const response = await AuthService.getTenants();
  return response;
};

export function useGetTenants(isAuthTokenSet: boolean) {
  const { data } = useQuery({
    queryKey: ['tenants'],
    queryFn: getTenants,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isAuthTokenSet,
  });

  return { tenants: data };
}
